import React from "react"
import { useDispatch, useSelector, batch } from "react-redux"

import user from "../reducers/user"
import reply from "../reducers/reply"



import "./footer.css"

import image from "../image/gluconutris.png"

const Footer = () => {
  const accessToken = useSelector((store) => store.user.accessToken)
  const dispatch = useDispatch()

  const onButtonClick = () => {
    batch(() => {
      dispatch(user.actions.setUsername(null))
      dispatch(user.actions.setRole(null))

      dispatch(user.actions.setAccessToken(null))
      dispatch(reply.actions.setIsSubmitted(false))

    })
  }

  return (
    <>
      <footer>
        <div className="footer">
          
          <a href="https://www.gluconutris.com/">
            <img src={image} alt="GlucoNutris Logo" width="120" height="25.52"/>
          </a>

          <h5>Address: Stockholm, Sweden</h5>

          <a href="mailto: info@gluconutris.com">
            <h5>Contact</h5>
          </a>
          {accessToken && (
            <button 
              className="btn-logout" 
              onClick={onButtonClick}
            >
              Logout
            </button>
          )}
        </div>
      </footer>
    </>
  )
}

export default Footer